import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Space } from '@app/core/model/entities/asset/space';
import { SpacesService } from '@app/features/main/views/organization-spaces/spaces.service';
import { eq } from '@app/shared/extra/filter-model-builder';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap, tap } from 'rxjs/operators';

export const lteSpaceParentProperty = (spacesService: SpacesService, field: string, spaceToUpdate: Space): AsyncValidatorFn => {

  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    let newFieldValue = 0;
    let parentArea: number;

    if (control.pristine || !(spaceToUpdate instanceof Space) || !spaceToUpdate.parentPath?.length) {
      return of(null);
    }

    return control.valueChanges.pipe(
      debounceTime(250),
      distinctUntilChanged(),
      switchMap(value => {
        newFieldValue = value as number;
        return spacesService.loadSpace(spaceToUpdate.parentPath.last());
      }),
      switchMap((parentSpace: Space) => {
        parentArea = parentSpace.properties[field] as number;

        if (!parentArea) {
          return of(null);
        }
        // Add filter to fetch only children
        return spacesService.loadAllSpaces({filters: [eq('parentPath', spaceToUpdate.parentPath.last())]});
      }),
      map((spaces: Space[] | null) => {

        if (!spaces?.length) {
          return null;
        }

        const totalArea = spaces
          .filter(space => {
            return space.id != spaceToUpdate.id
              && space.properties[field]
              && spaceToUpdate.parentPath.length == space.parentPath.length;
          })
          .map(space => space.properties[field])
          .reduce((prev, acc) => +prev + +acc, newFieldValue);

        if (totalArea > parentArea) {
          return {lteSpaceParentProperty: true};
        }

        return null;
      }),
      first(),
      tap(() => control.markAsTouched())
    );
  };
};
